// pages/LuxotticaUnauthorizedPage.jsx
import { useNavigate } from 'react-router-dom';
import UnauthorizedPage from '@/components/UnauthorizedPage';
import { buildPath } from '@/utils/routeBuilder';

const LuxotticaUnauthorizedPage = () => {
  const navigate = useNavigate();

  return (
    <UnauthorizedPage
      projectName="Luxottica"
      onGoToDashboard={() => navigate(buildPath('/luxottica'))}
      onSignInDifferent={() => navigate(buildPath('/luxottica/login'))}
      brandColor="blue"
    />
  );
};

export default LuxotticaUnauthorizedPage;